import { ReactNode } from "react";

interface TelefoneNumbersProps {
  children: ReactNode;
}

export function TelefoneNumbers({ children }: TelefoneNumbersProps) {
  return (
    <div className="mt-4 grid w-full grid-cols-3 gap-4 text-center  text-white">
      {children}
    </div>
  );
}
